import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { AuthService } from '../services/auth/user-auth/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        Swal.close();

        if (error.status === 401 || error.status === 403) {
          this.authService.logout();
        }

        const apiMessage = error.error?.message || error.error.title || 'Erro desconhecido';
        const listaErros = Array.isArray(error.error?.errors)
          ? error.error.errors.join('\n')
          : error.error?.errors || '';
        const isValidation = error.status === 400;

        Swal.fire({
          icon: isValidation ? 'warning' : 'error',
          title: isValidation ? 'Atenção' : `Erro: ${error.status}`,
          html: `<p>${apiMessage}</p><pre>${listaErros}</pre>`,
        });

        return throwError(() => error);
      })
    );
  }
}
